export const SET_ERROR_SOURCE = (state, value) => {
  state.source = value
}

export const SET_HTML_ERROR = (state, value) => {
  state.html = value
}
